<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

import { useI18n } from 'vue-i18n';
const props = defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  // Unix em SEGUNDOS (serializer manda scheduled_at.to_i; 0 = sem agendamento)
  scheduledAt: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();

const scheduledAtLabel = computed(() => {
  if (!props.scheduledAt) return '';
  return new Date(props.scheduledAt * 1000).toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
});
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 min-w-0 max-w-full">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12 break-words min-w-0">
      {{ inboxName }}
    </span>
  </div>

  <template v-if="scheduledAtLabel">
    <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
      {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
    </span>
    <span class="text-sm font-medium text-n-slate-12">
      {{ scheduledAtLabel }}
    </span>
  </template>
</template>
